import { useInfiniteQueryBuilder, useMutationBuilder } from "src/query/useBuilders";
import {
  CREATE,
  DELETE,
  PERMISSIONS,
  SEARCH,
  UPDATE,
  USER_ACCESS,
} from "../../queryKeys";
import { permissionsApi } from "src/services/experiences/storyboardSettings/permissions";
import {
  StoryboardUsersSearchRequest,
} from "src/types/experiences/storyboardSettings";

const PAGE_SIZE = 20;

export const useStoryboardUsersQuery = (
  storyboardId: string,
  request: StoryboardUsersSearchRequest = {},
) => {
  return useInfiniteQueryBuilder(
    [PERMISSIONS, SEARCH, storyboardId, JSON.stringify(request)],
    ({ pageParam = 0 }) =>
      permissionsApi.searchStoryboardUsers({
        storyboardId,
        request: {
          page: pageParam,
          limit: PAGE_SIZE,
          sort: request.sort, 
          order: request.order, 
        },
      }),
    0,
    (lastPage) =>
      lastPage.currentPage + 1 < lastPage.totalPages
        ? lastPage.currentPage + 1
        : undefined,
    undefined,
    Boolean(storyboardId),
  );
};

export const useAddStoryboardUsersMutation = () => {
  return useMutationBuilder(
    [PERMISSIONS, CREATE],
    permissionsApi.addStoryboardUsers,
    [PERMISSIONS],
  );
};

export const useUpdateStoryboardUserAccessMutation = () => {
  return useMutationBuilder(
    [USER_ACCESS, UPDATE],
    permissionsApi.updateStoryboardUserAccess,
    [PERMISSIONS],
  );
};

export const useRemoveStoryboardUserAccessMutation = () => {
  return useMutationBuilder(
    [USER_ACCESS, DELETE],
    permissionsApi.removeStoryboardUserAccess,
    [PERMISSIONS],
  );
};
